import { useMemo } from "react";

import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionHeaderName,
  ModalBody,
  ModalFooter,
} from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

export const ArchiveClassroomsResultSlide = ({
  classrooms = [],
  blocked = [],
  onCancel,
  onConfirm,
}) => {
  const getClassroomName = (classroomId) =>
    classrooms.find((c) => c.classroomId === classroomId)?.name;

  const getFullName = (user) =>
    [user.firstName, user.lastName].filter(Boolean).join(" ");

  const buttonsLabels = useMemo(() => {
    const isSingleOperation = classrooms?.length === 1;

    return {
      cancel: isSingleOperation ? "No, Cancel" : "Skip Blocked",
      confirm: "Yes, Archive All",
    };
  }, [classrooms, blocked]);

  return (
    <>
      <ModalBody className="archive-classrooms-result-slide">
        <div className="blocked-warning">
          The following{" "}
          {blocked.length === 1 ? "classroom" : `${blocked.length} classrooms`}{" "}
          {blocked.length === 1 ? "has" : "have"} users assigned to only one
          classroom. Would you like to archive{" "}
          {blocked.length === 1 ? "it" : "them"} including the users?
        </div>
        <div className="blocked-list">
          {blocked.map(({ classroomId, users }) => (
            <Accordion
              className="blocked-classroom-accordion"
              key={classroomId}
              isOpen={false}
            >
              <AccordionHeader>
                <AccordionHeaderName>
                  {getClassroomName(classroomId)}
                </AccordionHeaderName>
              </AccordionHeader>
              <AccordionBody>
                <ul className="blocked-users-list">
                  {users.map((user) => (
                    <li key={user.userId ?? user.id}>{getFullName(user)}</li>
                  ))}
                </ul>
              </AccordionBody>
            </Accordion>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onCancel}>{buttonsLabels.cancel}</Button>
        <Button destructive onClick={onConfirm}>
          {buttonsLabels.confirm}
        </Button>
      </ModalFooter>
    </>
  );
};
